import React from "react";
import { SelectChangeEvent, Typography, Paper, Grid } from "@mui/material";
import InfoButton from "./InfoButton";
import { useTranslation } from "react-i18next";
import { ComoSelect, ComoSelectOption } from "../Common/ComoSelect";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

interface ModelBehaviorProps {
  value: string;
  handleChange: (
    event: SelectChangeEvent<string>,
    child: React.ReactNode,
  ) => void;
  error?: boolean;
  helperText?: string;
}

const ModelBehavior: React.FC<ModelBehaviorProps> = ({
  value,
  handleChange,
  error,
  helperText,
}) => {
  const { t } = useTranslation("expertForm");
  const { colors: workspace } = useWorkspaceColors();

  const options: ComoSelectOption[] = [
    { id: "consistent", label: t("expertForm.modelBehaviorOptionConsistent") },
    { id: "creative", label: t("expertForm.modelBehaviorOptionCreative") },
  ];

  const selectedOption = options.find((opt) => opt.id === value);

  const handleSelectChange = (option: ComoSelectOption) => {
    const event = {
      target: {
        name: "modelBehavior",
        value: option.id as string,
      },
    } as SelectChangeEvent<string>;
    handleChange(event, null);
  };

  return (
    <Grid item xs={12}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 2,
          border: `1px solid ${colors.gray200}`,
          borderLeft: `4px solid ${workspace.primary_dark}`,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: workspace.primary_dark,
            fontWeight: 600,
            display: "flex",
            marginBottom: 2,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {t("expertForm.modelBehavior")}
          <InfoButton info={t("expertForm.modelBehaviorInfo")} />
        </Typography>
        <ComoSelect
          options={options}
          selectedOption={selectedOption}
          onSelect={handleSelectChange}
          placeholder={t("expertForm.modelBehavior")}
        />
        {error && helperText && (
          <Typography variant="caption" color="error" sx={{ ml: 2 }}>
            {helperText}
          </Typography>
        )}
      </Paper>
    </Grid>
  );
};

export default ModelBehavior;
